<template>
    <div class="admin app-main-layout">
        <div class="content" :class="{'navOpen':navOpen}">
            <nav class="orange darken-2">
                <div class="nav-wrapper">
                    <div class="burger">
                        <a href="#" @click.prevent="navOpen=!navOpen">
                            <i class="material-icons black-text">dehaze</i>
                        </a>
                    </div>

                </div>
            </nav>

            <ul id="slide-out" class="sidenav app-sidenav" ref="sidenav">
                <li><div class="user-view">
                    <router-link :to="{name:'home'}" title="На главную"><img :src="require('@/assets/img/expertSlider_bg.png')"></router-link>
                </div></li>

                <li><router-link :to="{params:{page:'home'}}"><i class="material-icons">home</i>Home</router-link></li>
                <li><div class="divider"></div></li>
                <li><router-link :to="{params:{page:'about'}}"><i class="material-icons">description</i>About</router-link></li>
                <li><div class="divider"></div></li>
                <li><router-link :to="{params:{page:'case'}}"><i class="material-icons">work</i>Projects</router-link></li>
            </ul>
            <main class="app-content" :class="{full: !navOpen}">
                <div class="app-page">
                    <component :is="$route.params.page"></component>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import materialize from 'materialize-css/dist/js/materialize.min'
    import HomeUpdate from '@/admin/app/HomeUpdate'
    import AboutUpdate from '@/admin/app/AboutUpdate'
    import CaseUpdate from '@/admin/app/CaseUpdate'
    export default {
        name: "Admin",
        data:()=>({
            instances: null,
            navOpen: false,
        }),
        watch:{
            navOpen(){
                if (this.navOpen) {
                    this.instances.open()
                }else{
                    this.instances.close()
                }
            }
        },
        components:{
            home:HomeUpdate,
            about:AboutUpdate,
            case:CaseUpdate
        },
        mounted(){
            this.instances = M.Sidenav.init(this.$refs.sidenav,{});
        },
        beforeRouteEnter(to, from, next) {
            next(async vm => {
                if (!vm.$store.state.tokenConfirmed) {
                    let token = vm.$cookie.get('token');
                    if (token) {
                        await vm.$store.dispatch('confirmToken', {vm: vm, token});
                        if (!vm.$store.state.tokenConfirmed) {
                            vm.$router.push({name: 'adminlogin'});
                        }
                    } else {
                        vm.$router.push({name: 'adminlogin'});
                    }
                }
            })
        }
    }
</script>
<style scoped lang="scss">
    .admin {
        @import "https://fonts.googleapis.com/icon?family=Material+Icons";
        @import "~materialize-css/sass/materialize";
        nav{
            .burger{
                width: 30px;
                left: 20px;

                position: fixed;
                top: 0;
                height: 64px;
                z-index: 100;
                a{
                    position: relative;
                    transition: .2s linear;
                }
            }
        }

        display: flex;
        justify-content: flex-end;
        .content{
            width: 100%;
            transition: .2s;
            &.navOpen{
                width: calc(100% - 300px);
                .burger{
                    left: 320px;
                    transition: .2s;
                }
            }
        }
        .user-view {
            margin-bottom: 6vh;
            img{
                width: 15%;
            }
        }

    }

</style>